import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Layout from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Layout,
    redirect: "/custom",
    children: [
      {
        path: "/template",
        name: "Template",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../modules/template/Index.vue"),
        meta: {
          activeName: "Template",
        },
      },
      {
        path: "/template-detail",
        name: "TemplateDetail",
        component: () => import("../modules/template/Detail.vue"),
        meta: {
          activeName: "Template",
        },
      },
      {
        path: "/fragment",
        name: "Fragment",
        component: () => import("../modules/fragment/Index.vue"),
        meta: {
          activeName: "Fragment",
        },
      },
      {
        path: "/fragment-detail",
        name: "FragmentDetail",
        component: () => import("../modules/fragment/Detail.vue"),
        meta: {
          activeName: "Fragment",
        },
      },
      {
        path: "/custom",
        name: "Custom",
        component: () => import("../modules/custom/Index.vue"),
        meta: {
          activeName: "Custom",
        },
      },
      {
        path: "/custom-detail",
        name: "CustomDetail",
        component: () => import("../modules/custom/Detail.vue"),
        meta: {
          activeName: "Custom",
        },
      },
      {
        path: "/destroy",
        name: "Destroy",
        component: () => import("../modules/destroy/Index.vue"),
        meta: {
          activeName: "Destroy",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, form, next) => {
  // document.title = to.name as string;
  next();
});

export default router;
